<template>
  <div class="chat-widget elevated-card d-flex" style="flex-direction: column; width: 18.1875rem">
    <div v-for="(element, element_i) in list.elements" :key="element_i">
      <v-divider v-if="element_i > 0 && element_i <= item_to_add"></v-divider>
      <div v-if="element_i < item_showed">
        <div class="list-title">{{ element.title }}</div>
        <div class="list-subtitle">{{ element.subtitle }}</div>
        <div class="list-item d-flex">
          <div class="d-flex" style="flex-direction: column; padding-right: 1rem">
            <div v-for="(button, button_i) in element.buttons" :key="button_i">
              <button v-ripple class="chat-btn hover-btn text-none" style="margin-top: 0.5rem" :style="`color: ${config.main_color}`" variant="outlined" @click="click(button)">
                {{ button.title }}
              </button>
            </div>
          </div>
          <div v-if="element.image_url">
            <v-img :src="element.image_url" :alt="element.title" style="height: 5.3125rem; width: 5.3125rem">
              <template v-slot:placeholder>
                <v-skeleton-loader type="image" />
              </template>
            </v-img>
          </div>
        </div>
      </div>
      <div v-else-if="element_i === item_showed" class="list-plus d-flex">
        <button v-ripple class="chat-btn hover-btn text-none" :style="`color: ${config.main_color}`" variant="outlined" @click="addItem" aria-label="chat-list-add-btn">
          <v-icon :color="config.main_color" class="plus-btn">mdi-plus</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import global_config from '@/../config.json'
import { onMounted, nextTick, ref, defineProps } from 'vue'
import { useStore } from 'vuex'

// Init modules
const store = useStore()

// Data
const config = ref(global_config)
const item_showed = ref(null)
const item_to_add = ref(null)

// Props
const { list, chat_id, message_id } = defineProps({
  list: Object,
  chat_id: String,
  message_id: String
})

const click = ({ type, title, value }) => {
  if (type === 'web_url') window.open(value, '_blank')
  else store.dispatch('sendMessageToSocket', { title, value })
}
const addItem = () => {
  var container_element = document.getElementById('chat_container')
  var chat_element = document.getElementById(chat_id)
  var message_element = document.getElementById(message_id)
  const old_scroll_height = message_element.scrollHeight

  item_showed.value += item_to_add.value
  nextTick(() => {
    const new_scroll_height = message_element.scrollHeight
    const scroll_amount = new_scroll_height - old_scroll_height
    const available_space = container_element.clientHeight - (chat_element.offsetTop + message_element.offsetTop + old_scroll_height - container_element.scrollTop) + 100

    if (available_space < scroll_amount) container_element.scrollTop = container_element.scrollTop + scroll_amount
  })
}

// Mounted
onMounted(() => {
  const { default_num_of_elements = null, default_num_of_elements_to_add = null } = list
  item_showed.value = default_num_of_elements ? default_num_of_elements : 1
  item_to_add.value = default_num_of_elements_to_add ? default_num_of_elements_to_add : 1
})
// export default {
//   name: 'List',
//   data() {
//     return {
//       config: global_config,
//       item_showed: null,
//       item_to_add: null
//     }
//   },
//   props: {
//     list: Object,
//     chat_id: String,
//     message_id: String
//   },
//   methods: {
//     click({ type, title, value }) {
//       if (type === 'web_url') window.open(value, '_blank')
//       else $store.dispatch('sendMessageToSocket', { title, value })
//     },
//     addItem() {
//       var container_element = document.getElementById('chat_container')
//       var chat_element = document.getElementById(this.chat_id)
//       var message_element = document.getElementById(this.message_id)
//       const old_scroll_height = message_element.scrollHeight

//       this.item_showed += this.item_to_add
//       this.$nextTick(() => {
//         const new_scroll_height = message_element.scrollHeight
//         const scroll_amount = new_scroll_height - old_scroll_height
//         const available_space = container_element.clientHeight - (chat_element.offsetTop + message_element.offsetTop + old_scroll_height - container_element.scrollTop) + 100

//         if (available_space < scroll_amount) container_element.scrollTop = container_element.scrollTop + scroll_amount
//       })
//     }
//   },
//   mounted() {
//     const { default_num_of_elements = null, default_num_of_elements_to_add = null } = this.list
//     this.item_showed = default_num_of_elements ? default_num_of_elements : 1
//     this.item_to_add = default_num_of_elements_to_add ? default_num_of_elements_to_add : 1
//   }
// }
</script>

<style scope>
.list-title {
  padding: 1rem 1rem 0.5rem 1rem;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.625rem;
  color: #1a1a1a;
}

.list-subtitle {
  padding: 0 1rem;
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  color: #828282;
}

.list-item {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 1rem 1rem;
}

.list-plus {
  justify-content: center;
  padding: 1rem 0;
}

.v-skeleton-loader {
  border-radius: 0;
}
</style>
